const data = [
    { value: 1, name: "Ativo" },
    { value: 2, name: "Inativo" },
]

export default [...data]